<swiper-container class="pack-item-1 swiper-container" [appSwiper]="config" init="false">
  @for (product of products; track product) {
    <swiper-slide class="swiper-slide card-size">
      <mat-card appearance="outlined" class="fx-col">
        @if (contentLoaded) {
          <div class="product-img">
            <a class="product-link"
              (click)="openProductDialog(product);">
              <img [src]="configService.localSettings.Disco.DiscoUrl+'/CMS/Images/Inventory/'+$safeNavigationMigration(product?.ImageUrl)"
                [default]="'assets/images/product/no-img.png'" alt="">
              </a>
            </div>
          }
          <div class="product-info-wrapper fx-col">
            @if (contentLoaded) {
              <div class="title-wrap text-center card-height fx-row fx-main-center fx-cross-center"
                (click)="openProductDialog(product);">
              <h4
                [textContent]="($safeNavigationMigration(product?.ProductName) | slice: 0:10) + (product?.ProductName.length > 10 ? '...':'')">
              </h4>
            </div>
          }
          @if (contentLoaded) {
            <div class="price-wrap text-center fx-row fx-main-center fx-cross-center">
              <p>${{product.Price | number : '1.2-2'}}</p>
            </div>
          }
          @if (contentLoaded) {
            <div class="btn-wrap  text-center fx-row fx-main-center fx-cross-center">
              <a (click)="addToCart(product)" mat-raised-button
              color="primary">{{'unifiedapplication_add_to_cart' | translate}}</a>
            </div>
          }
        </div>
      </mat-card>
    </swiper-slide>
  }
  <div slot="container-end" class="footerButton">
    <button mat-button class="swiper-button-prev swipe-arrow">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button mat-button class="swiper-button-next swipe-arrow">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </div>
</swiper-container>